import Vue from 'vue'
import Vuex from 'vuex'
import {firebase, db, auth} from '@/fb'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cart_id:null
  },
  getters: {
    
  },
  mutations: {
      
  },
  actions: {
    
  },
})